'use strict';

var Reflux = require('reflux');

var DatasourceActions = Reflux.createActions(["loadAll", "create", "edit", "submit", "cancel", "delete", "deleteItems", "copyItemsTo", "loadItems", "assignUser", "assignTeam", "assignProject", "unassignUser", "unassignTeam", "unassignProject", "updateContent", "createContent", "changeForSale"]);

module.exports = DatasourceActions;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/actions/datasource.js
 **/